// src/AuthContext.js
import React, { createContext, useState, useContext } from 'react';

// Create the context for authentication
const AuthContext = createContext();

// Provider component that will wrap your app
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // Function to log in the user
  const login = (userData) => {
    setUser(userData);
  };

  // Function to log out the user
  const logout = () => {
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use the AuthContext in components
export const useAuth = () => {
  return useContext(AuthContext);
};
